import { DEFAULT_LANG, pickLang, t as protocolT, type Lang } from '@treetrack/protocol';

const KEY = 'treetrack.lang';
let current: Lang = DEFAULT_LANG;

try {
  const saved = localStorage.getItem(KEY);
  current = saved === 'en' || saved === 'es' ? saved : pickLang(navigator.languages ?? [navigator.language]);
} catch {
  current = DEFAULT_LANG;
}

const listeners = new Set<() => void>();

export function getLang(): Lang {
  return current;
}

export function setLang(lang: Lang): void {
  current = lang;
  try {
    localStorage.setItem(KEY, lang);
  } catch {
    /* private mode */
  }
  document.documentElement.lang = lang;
  for (const l of listeners) l();
}

export function onLangChange(fn: () => void): () => void {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

export function t(key: string, params?: Record<string, string | number>): string {
  return protocolT(current, key, params);
}

/** A label that lives only in this app (not a protocol string): pick by language. */
export function L(es: string, en: string): string {
  return current === 'es' ? es : en;
}

/** Species name in the current language. */
export function speciesName(s: { name_es: string; name_en: string } | null | undefined): string {
  if (!s) return '—';
  return current === 'es' ? s.name_es : s.name_en;
}
